module.exports = __webpack_public_path__ + "img/next-big-future.3eb47964.png";